import { AppDispatch } from 'src/app/store'
import { UsersAdmin, Withdrawal } from 'src/core/models'
import {
  AdminDeposit,
  AdminTransfer,
  PurchaseDocument
} from 'src/core/models/admin-statics.type'
import * as api from './api'
import * as reducers from './slice'
import {
  buildCarPreviewList,
  buildPlanePreviewList,
  buildParcelPreviewList,
  getParcelSplitedArrayIntoPieces
} from './helpers'
import { getFilteredDocuments } from 'src/core/helpers'
const BULKS_NUMBER = 200

export const createBusinessCertificate =
    (payload: any) => async (dispatch: AppDispatch) => {
      try {
        dispatch(reducers.setGenerateCertificateLoading(true))
        const data = await api.createIntegrationCertificate(payload)
        dispatch(reducers.setGenerateCertificateLoading(false))
        dispatch(reducers.setGenerateCertificateResponse(data))
      } catch (error) {
        dispatch(reducers.setGenerateCertificateError(error))
      }
    }

export const getAdminStatics =
    (currency: string) => async (dispatch: AppDispatch) => {
      try {
        dispatch(reducers.setAdminStaticsLoading(true))
        const data = await api.getAdminStatics(currency)
        dispatch(reducers.setAdminStaticsLoading(false))
        dispatch(reducers.setAdminStaticsData(data))
      } catch (error) {
        return Promise.reject(error)
      }
    }

export const buildPreviewList =
    (type: any, keys: any, excelData: any) => (dispatch: AppDispatch) => {
      try {
        dispatch(reducers.setMassiveCalculationLoadingPreview(true))
        let list = []
        if (type === 'CARS') {
          list = buildCarPreviewList(keys, excelData)
        } else if (type === 'PLANE') {
          list = buildPlanePreviewList(keys, excelData)
        } else if (type === 'PARCEL') {
          list = buildParcelPreviewList(keys, excelData)
        }
        dispatch(reducers.setMassiveCalculationPreviewList(list))
        dispatch(reducers.setMassiveCalculationLoadingPreview(false))
      } catch (error) {
        return Promise.reject(error)
      }
    }

export const getCalculateData =
    (list: any[], url: string, calculeType: any) =>
      async (dispatch: AppDispatch) => {
        dispatch(reducers.setMassiveCalculationResponseResetData())
        dispatch(reducers.setMassiveCalculationResponseLoading(true))
        const newList = calculeType?.isParcel
          ? getParcelSplitedArrayIntoPieces(list, BULKS_NUMBER)
          : list
        for (const item of newList) {
          try {
            const response = await api.buildCalculateResponse(
              item,
              url,
              calculeType
            )
            const params = calculeType?.isParcel
              ? response
              : { response, item }
            dispatch(reducers.setMassiveCalculationResponseAddData(params))
          } catch (error) {
            dispatch(
              reducers.setMassiveCalculationResponseErrorMessage(error)
            )
          }
        }
        dispatch(reducers.setMassiveCalculationResponseLoading(false))
      }

export const getUsersAdmin = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setAdminUsersLoading(true))
    const data: UsersAdmin[] = await api.getUsersAdminAPI()
    dispatch(reducers.setAdminUsersData(data))
    dispatch(reducers.setAdminUsersLoading(false))
  } catch (error) {
    dispatch(reducers.setAdminUsersLoading(false))
  }
}

export const validateUser =
    (userId: number, usersList: UsersAdmin[]) =>
      async (dispatch: AppDispatch) => {
        try {
          dispatch(reducers.setValidateUserLoading(true))
          dispatch(reducers.setValidateUserCurrentId(userId))
          await api.validateUserAPI(userId)
          /* Load Updated List */
          const newListUpdated: UsersAdmin[] = usersList.map((user) => {
            if (user.id !== userId) return user
            return { ...user, is_validate: true }
          })
          dispatch(reducers.setAdminUsersData(newListUpdated))
          /* Finish Action */
          dispatch(reducers.setValidateUserSuccess(true))
          dispatch(reducers.setValidateUserLoading(false))
          dispatch(reducers.setValidateUserCurrentId(null))
        } catch (error) {
          dispatch(reducers.setValidateUserLoading(false))
          dispatch(reducers.setValidateUserSuccess(false))
          dispatch(reducers.setValidateUserCurrentId(null))
        }
      }

export const rejectUser =
    (userId: number, rejectReason: string, usersList: UsersAdmin[]) =>
      async (dispatch: AppDispatch) => {
        try {
          dispatch(reducers.setRejectUserLoading(true))
          dispatch(reducers.setRejectUserCurrentId(userId))
          await api.rejectUserAPI(userId, rejectReason)
          /* Load Updated List */
          const newListUpdated: UsersAdmin[] = usersList.map((user) => {
            if (user.id !== userId) return user
            return { ...user, is_rejected: true }
          })
          dispatch(reducers.setAdminUsersData(newListUpdated))
          /* Finish Action */
          dispatch(reducers.setRejectUserSuccess(true))
          dispatch(reducers.setRejectUserLoading(false))
        } catch (error) {
          dispatch(reducers.setRejectUserLoading(false))
          dispatch(reducers.setRejectUserSuccess(false))
          dispatch(reducers.setRejectUserCurrentId(null))
        }
      }

export const getWithdrawals = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setWithdrawalsLoading(true))
    const data: Withdrawal[] = await api.getWithdrawalsAPI()
    dispatch(reducers.setWithdrawalsData(data))
    dispatch(reducers.setWithdrawalsLoading(false))
  } catch (error) {
    dispatch(reducers.setWithdrawalsLoading(false))
  }
}

export const validateWithdrawal =
    (withdrawalID: number, withdrawalList: Withdrawal[]) =>
      async (dispatch: AppDispatch) => {
        try {
          dispatch(reducers.setValidateWithdrawalsLoading(true))
          dispatch(reducers.setValidateCurrenctWithdrawalId(withdrawalID))
          await api.validateWithdrawalsAPI(withdrawalID)
          /* Load Updated List */
          const newListUpdated: Withdrawal[] = withdrawalList.map(
            (withdrawal) => {
              if (withdrawal.id !== withdrawalID) return withdrawal
              return { ...withdrawal, status: 'paid' }
            }
          )
          dispatch(reducers.setWithdrawalsData(newListUpdated))
          /* Finish Action */
          dispatch(reducers.setValidateWithdrawalsSuccess(true))
          dispatch(reducers.setValidateWithdrawalsLoading(false))
        } catch (error) {
          dispatch(reducers.setValidateWithdrawalsLoading(false))
          dispatch(reducers.setValidateWithdrawalsSuccess(false))
        }
      }

export const cancelWithdrawal =
    (withdrawalID: number, withdrawalList: Withdrawal[]) =>
      async (dispatch: AppDispatch) => {
        try {
          dispatch(reducers.setCancelWithdrawalsLoading(true))
          dispatch(reducers.setCancelCurrenctWithdrawalId(withdrawalID))
          await api.cancelWithdrawalsAPI(withdrawalID)
          /* Load Updated List */
          const newListUpdated: Withdrawal[] = withdrawalList.map(
            (withdrawal) => {
              if (withdrawal.id !== withdrawalID) return withdrawal
              return { ...withdrawal, status: 'canceled' }
            }
          )
          dispatch(reducers.setWithdrawalsData(newListUpdated))
          /* Finish Action */
          dispatch(reducers.setCancelWithdrawalsSuccess(true))
          dispatch(reducers.setCancelWithdrawalsLoading(false))
        } catch (error) {
          dispatch(reducers.setCancelWithdrawalsLoading(false))
          dispatch(reducers.setCancelWithdrawalsSuccess(false))
        }
      }

// DOCUMENTS

export const getPurchaseDocuments =
    (filterText?: string) => async (dispatch: AppDispatch) => {
      try {
        dispatch(reducers.setDocumentsLoading(true))
        const data: PurchaseDocument[] = await api.getDocumentsAPI()
        dispatch(reducers.setDocumentsData(data))
        const newList = getFilteredDocuments(filterText, data)
        dispatch(reducers.setDocumentsFiltered(newList))
        dispatch(reducers.setDocumentsLoading(false))
      } catch (error) {
        dispatch(reducers.setDocumentsLoading(false))
      }
    }

export const validateCancellationDocument =
    (documentId: number) => async (dispatch: AppDispatch) => {
      try {
        dispatch(
          reducers.setValidateCancelationValue({
            key: 'loading',
            value: true
          })
        )
        dispatch(
          reducers.setValidateCancelationValue({
            key: 'currentDocumentId',
            value: documentId
          })
        )
        await api.validateCancellationAPI(documentId)
        dispatch(
          reducers.setValidateCancelationValue({
            key: 'success',
            value: true
          })
        )
        dispatch(
          reducers.setValidateCancelationValue({
            key: 'loading',
            value: false
          })
        )
      } catch (error) {
        dispatch(
          reducers.setValidateCancelationValue({
            key: 'error',
            value: error
          })
        )
        dispatch(
          reducers.setValidateCancelationValue({
            key: 'loading',
            value: false
          })
        )
      }
    }

export const validateReceiptDocument =
    (documentId: number) => async (dispatch: AppDispatch) => {
      try {
        dispatch(
          reducers.setValidateReceiptValue({
            key: 'loading',
            value: true
          })
        )
        dispatch(
          reducers.setValidateReceiptValue({
            key: 'currentDocumentId',
            value: documentId
          })
        )
        await api.validateReceiptAPI(documentId)
        dispatch(
          reducers.setValidateReceiptValue({
            key: 'success',
            value: true
          })
        )
        dispatch(
          reducers.setValidateReceiptValue({
            key: 'loading',
            value: false
          })
        )
      } catch (error) {
        dispatch(
          reducers.setValidateReceiptValue({ key: 'error', value: error })
        )
        dispatch(
          reducers.setValidateReceiptValue({
            key: 'loading',
            value: false
          })
        )
      }
    }

export const validateTaxReliefDocument =
    (documentId: number) => async (dispatch: AppDispatch) => {
      try {
        dispatch(
          reducers.setValidateTaxReliefValue({
            key: 'loading',
            value: true
          })
        )
        dispatch(
          reducers.setValidateTaxReliefValue({
            key: 'currentDocumentId',
            value: documentId
          })
        )
        await api.validateTaxReliefAPI(documentId)
        dispatch(
          reducers.setValidateTaxReliefValue({
            key: 'success',
            value: true
          })
        )
        dispatch(
          reducers.setValidateTaxReliefValue({
            key: 'loading',
            value: false
          })
        )
      } catch (error) {
        dispatch(
          reducers.setValidateTaxReliefValue({
            key: 'error',
            value: error
          })
        )
        dispatch(
          reducers.setValidateTaxReliefValue({
            key: 'loading',
            value: false
          })
        )
      }
    }

export const validateCarbonForwardFile =
    (documentId: number) => async (dispatch: AppDispatch) => {
      try {
        dispatch(
          reducers.setValidateCarbonForwardfValue({
            key: 'loading',
            value: true
          })
        )
        dispatch(
          reducers.setValidateCarbonForwardfValue({
            key: 'currentDocumentId',
            value: documentId
          })
        )
        await api.validateCarbonForwardAPI(documentId)
        dispatch(
          reducers.setValidateCarbonForwardfValue({
            key: 'success',
            value: true
          })
        )
        dispatch(
          reducers.setValidateCarbonForwardfValue({
            key: 'loading',
            value: false
          })
        )
      } catch (error) {
        dispatch(
          reducers.setValidateCarbonForwardfValue({
            key: 'error',
            value: error
          })
        )
        dispatch(
          reducers.setValidateCarbonForwardfValue({
            key: 'loading',
            value: false
          })
        )
      }
    }

export const getAdminTransfers = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setTransferLoading(true))
    const data: AdminTransfer[] = await api.getTransfersAPI()
    dispatch(reducers.setTransferData(data))
    dispatch(reducers.setTransferFiltered(data))
    dispatch(reducers.setTransferLoading(false))
  } catch (error) {
    dispatch(reducers.setTransferLoading(false))
  }
}

export const rejectBankTransfer =
    (transfer: number, bigTransferList: AdminTransfer[]) =>
      async (dispatch: AppDispatch) => {
        try {
          dispatch(
            reducers.setRejectTransferValue({
              key: 'currentTransfer',
              value: transfer
            })
          )
          dispatch(
            reducers.setRejectTransferValue({
              key: 'loading',
              value: true
            })
          )
          await api.rejectTransfers(transfer)
          const data: AdminTransfer[] = bigTransferList.filter(
            (t) => t.order.id !== transfer
          )
          dispatch(reducers.setTransferData(data))
          dispatch(reducers.setTransferFiltered(data))
          dispatch(
            reducers.setRejectTransferValue({
              key: 'success',
              value: true
            })
          )
          dispatch(
            reducers.setRejectTransferValue({
              key: 'loading',
              value: false
            })
          )
        } catch (error) {
          dispatch(
            reducers.setRejectTransferValue({
              key: 'error',
              value: true
            })
          )
          dispatch(
            reducers.setRejectTransferValue({
              key: 'success',
              value: true
            })
          )
          dispatch(
            reducers.setRejectTransferValue({
              key: 'loading',
              value: false
            })
          )
        }
      }

export const validateTransfer =
    (orderId: number, bigTransferList: AdminTransfer[]) =>
      async (dispatch: AppDispatch) => {
        try {
          dispatch(
            reducers.setValidateTransferValue({
              key: 'currentTransfer',
              value: orderId
            })
          )
          dispatch(
            reducers.setValidateTransferValue({
              key: 'loading',
              value: true
            })
          )
          await api.validateTransferAPI(orderId)
          const data: AdminTransfer[] = bigTransferList.filter(
            (t) => t.order.id !== orderId
          )
          dispatch(reducers.setTransferData(data))
          dispatch(reducers.setTransferFiltered(data))
          dispatch(
            reducers.setValidateTransferValue({
              key: 'success',
              value: true
            })
          )
          dispatch(
            reducers.setValidateTransferValue({
              key: 'loading',
              value: false
            })
          )
        } catch (error) {
          dispatch(
            reducers.setValidateTransferValue({
              key: 'error',
              value: error
            })
          )
          dispatch(
            reducers.setValidateTransferValue({
              key: 'success',
              value: false
            })
          )
          dispatch(
            reducers.setValidateTransferValue({
              key: 'loading',
              value: false
            })
          )
        }
      }

// ------------------ Admin Deposits -------------------------------

export const getAdminDeposits = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setAdminDepositsLoading(true))
    const data: AdminDeposit[] = await api.getDepositsAPI()
    dispatch(reducers.setAdminDepositsData(data))
    dispatch(reducers.setAdminDepositsLoading(false))
  } catch (error) {
    dispatch(reducers.setAdminDepositsLoading(false))
  }
}

/* Suppliers Actions */

export const initSuppliersInfoAPICron = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setAdminSuppliersLoading(true))
    await api.initSuppliersCronAPI()
    dispatch(reducers.setAdminSuppliersSuccess(true))
    dispatch(reducers.setAdminSuppliersError(false))
    dispatch(reducers.setAdminSuppliersLoading(false))
  } catch (error) {
    dispatch(reducers.setAdminSuppliersError(true))
    dispatch(reducers.setAdminSuppliersSuccess(false))
    dispatch(reducers.setAdminSuppliersLoading(false))
  }
}
